import { BASE_URL } from '@/config/public'
import { METHOD, request } from '@/utils/request'

export default {
  //查询回放列表
  getplaybackList: params => {
    return request(
      `${BASE_URL}/provider/ims/ejbb/playback/list`,
      //   METHOD.POST_JSON_ENCRYPT,
      METHOD.GET,
      params,
      { isNeedToken: false }
    )
  },
  // 查询精选主题页面
  getplayListFisrst: params => {
    return request(
      `${BASE_URL}/provider/ims/ejbb/playback/firstPage`,
      METHOD.GET,
      params,
      { isNeedToken: false }
    )
  },
  //回放视频增加点击数
  addClick: params => {
    return request(
      `${BASE_URL}/provider/ims/ejbb/playback/addClick`,
      METHOD.GET,
      params,
      { isNeedToken: false }
    )
  }
}
